__turbopack_context__.v({
  "badgeText": "W1kWJG_badgeText",
  "title": "W1kWJG_title",
  "titleWrapper": "W1kWJG_titleWrapper",
});
